// Mapeamento dos 48 times da Copa 2026 → bandeira (emoji) + ISO code (para fallbacks).
// Nomes batem com o que está em backend/seeds/fixtures_2026.json.

interface TeamInfo {
  flag: string;
  code: string;
}

const TEAMS: Record<string, TeamInfo> = {
  'México': { flag: '🇲🇽', code: 'MX' },
  'África do Sul': { flag: '🇿🇦', code: 'ZA' },
  'Coreia do Sul': { flag: '🇰🇷', code: 'KR' },
  'República Tcheca': { flag: '🇨🇿', code: 'CZ' },
  'Canadá': { flag: '🇨🇦', code: 'CA' },
  'Bósnia e Herzegovina': { flag: '🇧🇦', code: 'BA' },
  'Catar': { flag: '🇶🇦', code: 'QA' },
  'Suíça': { flag: '🇨🇭', code: 'CH' },
  'Brasil': { flag: '🇧🇷', code: 'BR' },
  'Marrocos': { flag: '🇲🇦', code: 'MA' },
  'Haiti': { flag: '🇭🇹', code: 'HT' },
  'Escócia': { flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿', code: 'SCT' },
  'Estados Unidos': { flag: '🇺🇸', code: 'US' },
  'Paraguai': { flag: '🇵🇾', code: 'PY' },
  'Austrália': { flag: '🇦🇺', code: 'AU' },
  'Turquia': { flag: '🇹🇷', code: 'TR' },
  'Alemanha': { flag: '🇩🇪', code: 'DE' },
  'Curaçao': { flag: '🇨🇼', code: 'CW' },
  'Costa do Marfim': { flag: '🇨🇮', code: 'CI' },
  'Equador': { flag: '🇪🇨', code: 'EC' },
  'Holanda': { flag: '🇳🇱', code: 'NL' },
  'Japão': { flag: '🇯🇵', code: 'JP' },
  'Suécia': { flag: '🇸🇪', code: 'SE' },
  'Tunísia': { flag: '🇹🇳', code: 'TN' },
  'Espanha': { flag: '🇪🇸', code: 'ES' },
  'Cabo Verde': { flag: '🇨🇻', code: 'CV' },
  'Arábia Saudita': { flag: '🇸🇦', code: 'SA' },
  'Uruguai': { flag: '🇺🇾', code: 'UY' },
  'Bélgica': { flag: '🇧🇪', code: 'BE' },
  'Egito': { flag: '🇪🇬', code: 'EG' },
  'Irã': { flag: '🇮🇷', code: 'IR' },
  'Nova Zelândia': { flag: '🇳🇿', code: 'NZ' },
  'França': { flag: '🇫🇷', code: 'FR' },
  'Senegal': { flag: '🇸🇳', code: 'SN' },
  'Iraque': { flag: '🇮🇶', code: 'IQ' },
  'Noruega': { flag: '🇳🇴', code: 'NO' },
  'Argentina': { flag: '🇦🇷', code: 'AR' },
  'Argélia': { flag: '🇩🇿', code: 'DZ' },
  'Áustria': { flag: '🇦🇹', code: 'AT' },
  'Jordânia': { flag: '🇯🇴', code: 'JO' },
  'Portugal': { flag: '🇵🇹', code: 'PT' },
  'RD Congo': { flag: '🇨🇩', code: 'CD' },
  'Uzbequistão': { flag: '🇺🇿', code: 'UZ' },
  'Colômbia': { flag: '🇨🇴', code: 'CO' },
  'Inglaterra': { flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', code: 'ENG' },
  'Croácia': { flag: '🇭🇷', code: 'HR' },
  'Gana': { flag: '🇬🇭', code: 'GH' },
  'Panamá': { flag: '🇵🇦', code: 'PA' },
};

export function flagOf(team: string): string {
  return TEAMS[team]?.flag ?? '⚽';
}

export function isBrasil(team: string): boolean {
  return team === 'Brasil';
}

export function matchHasBrasil(home: string, away: string): boolean {
  return isBrasil(home) || isBrasil(away);
}
